<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="updateAcademiaMigracion"
    >
      <header class="m-the-modal-header">
        <h5>MIGRAR ACADEMIA</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p>Se migrará la academia <strong>{{ migration.academyName }}</strong> desde la licencia
          <u>{{ migration.fromProd }}</u> hacia la licencia
          <u>{{ migration.toProd }}</u>.
        </p>
        <p>
          <small class="font-weight-bold text-color-billing-primary">
            ¿Estás seguro de ejecutar esta acción?
          </small>
        </p>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction cancel-text="Cancelar"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingAcademyMigrationModalMigrateAcademy',

  data () {
    return {
      buttonPrimary: {
        action: 'Confirmar',
        class: 'a-button-billing-primary',
        sending: false,
        type: 'submit'
      },

      migration: {
        academyName: '',
        fromProd: '',
        toProd: ''
      },

      params: {
        ventaOld: '',
        ventaNew: '',
        validarEmail: 1
      }
    }
  },

  created () {
    if (this.$modal.element[0].academia) {
      this.migration.academyName = this.$modal.element[0].academia.nombre
      this.migration.fromProd = this.$modal.element[0].venta.venta.concepto_venta
      this.migration.toProd = this.$modal.element[1].venta.venta.concepto_venta
    } else {
      this.migration.academyName = this.$modal.element[1].academia.nombre
      this.migration.fromProd = this.$modal.element[1].venta.venta.concepto_venta
      this.migration.toProd = this.$modal.element[0].venta.venta.concepto_venta
    }
  },

  methods: {
    updateAcademiaMigracion () {
      this.params = {
        ventaOld: this.$modal.element[0].venta.venta.id_venta,
        ventaNew: this.$modal.element[1].venta.venta.id_venta,
        validarEmail: 1
      }

      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.create('academia', 'updateAcademiaMigracion', this.params)
          .then(response => {
            console.log(response.data)
            this.$modal.updateData('updateMigratedData')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.buttonPrimary.sending = false
            this.$alerts.pushAlertNotTranslated('Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
              'a-alert-danger')
          })
      }
    }
  }
}
</script>
